import React from 'react';

const TopicsAccordion = ({ locations, loc, handlePopulateVariables, locationIsLoading }) => {
    return (
        <ul className="column" style={{ fontSize: "12px" }}>
            {locations.length > 0 && locations.map((location, index) => (
                <li
                    style={{
                        cursor: "pointer",
                        backgroundColor: loc.includes(location) ? '#175C7D' : '',
                        color: loc.includes(location) ? '#fff' : '#000',
                        display: loc.includes(location) ? 'block' : 'inherit'
                    }}
                    key={index}
                    onClick={() => handlePopulateVariables(location)}
                >
                    {location}
                </li>
            ))}
            {(locations.length === 0 && locationIsLoading) && (<img src="/assets/img/slice-and-dice-loader.svg" alt="" />)}
            {(locations.length === 0 && !locationIsLoading) && (<p>There are no locations for this organization</p>)}
        </ul>
    );
};

export default TopicsAccordion;